(ns ui.view.entity-creator.components
  (:require
   [clojure.string :as string]
   [common.localization :as loc]
   [common.util :as cu]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]
   [ui.editors.labelled-input.view :as input]
   [ui.util :as uu]
   [ui.view.entity-creator.model :as m]))

(defn mandatory-error?
  [{:keys [error-kw]}]
  (contains? #{:constraints/mandatory
               :constraint/mandatory-fn}
             error-kw))

(defn entity-validations-tooltip
  [args entity-name validations]
  (let [field-schemas @(rf/subscribe [m/field-schemas
                                      args])
        mandatory-validations (->> validations
                                   (keep (fn [[attribute error-msgs]]
                                           (let [mandatory-errors
                                                 (->> error-msgs
                                                      (filterv mandatory-error?))]
                                             (when (seq mandatory-errors)
                                               [attribute mandatory-errors]))))

                                   (into {}))
        other-validations (->> validations
                               (keep (fn [[attribute error-msgs]]
                                       (let [other-errors
                                             (->> error-msgs
                                                  (remove mandatory-error?))]
                                         (when (seq other-errors)
                                           [attribute (vec other-errors)]))))

                               (into {}))
        mandatory-list (when (seq mandatory-validations)
                         (->> mandatory-validations
                              keys
                              (mapv (fn [attribute]
                                      (let [fs (get field-schemas attribute)]
                                        (loc/field-name
                                         attribute
                                         fs))))
                              (string/join ", ")))
        mandatory-validations-str (when mandatory-list
                                    (loc/tr :mandatory-constraint/following-fields
                                            [mandatory-list]))
        ;; List of mandatory fields first for clarity, then rest:
        other-str (when (seq other-validations)
                    (->> other-validations
                         (mapcat (fn [[attribute error-msgs]]
                                   (let [field-schema (get field-schemas attribute)
                                         msgs (->> error-msgs
                                                   (mapv #(or (:error-message-str %)
                                                              (:error-message %)))
                                                   (filterv string?)
                                                   (mapv (fn [s]
                                                           (str (loc/field-name
                                                                 attribute
                                                                 field-schema)
                                                                ": " s))))]
                                     msgs)))
                         (string/join ", ")))
        validations-el (cond (and (seq mandatory-validations-str)
                                  (seq other-str))
                             [:div
                              [:div
                               {:class "mb-1"}
                               mandatory-validations-str]
                              [:div other-str]]

                             (seq mandatory-validations-str)
                             mandatory-validations-str

                             (seq other-str)
                             other-str

                             :else
                             nil)
        validations-el (when validations-el
                         (if entity-name
                           [:div (str entity-name ": ")
                            validations-el]
                           validations-el))]
    validations-el))

(defn validations-tooltip
  [args validations]
  (let [entity-type @(rf/subscribe [m/entity-type args])]
    (when (seq validations)
      (entity-validations-tooltip
       (assoc args :entity-type entity-type) nil validations))))

(defn creator-footer
  [{:keys [curtain?] :as args} close-modal!]
  (let [validations @(rf/subscribe [m/entity-validations
                                    (assoc args
                                           :entity-edits-path m/entity-edits-path)])
        disabled? (not (cu/blank-value? validations))
        tooltip-text (validations-tooltip args validations)]
    [:div
     {:class (uu/cm (if curtain?
                      "flex gap-4"
                      "flex justify-between w-full"))}
     [button/secondary-hollow
      {:on-click (fn [_]
                   (rf/dispatch [m/close-creator args])
                   (when (fn? close-modal!)
                     (close-modal!)))}
      (loc/tr :cancel)]
     [button/primary-solid
      {:on-click (fn [_]
                   (rf/dispatch [m/start-create args]))
       :tooltip tooltip-text
       :disabled? disabled?}
      (loc/tr :create)]]))

(defn finished-footer
  [{:keys [curtain?] :as args}]
  [:div
   {:class (uu/cm (if curtain?
                    "flex gap-4"
                    "flex justify-end w-full"))}
   [button/primary-solid
    {:on-click (fn [_]
                 (rf/dispatch [m/finish args]))}
    (loc/tr :close)]])

(defn processing-footer
  [{:keys [curtain?] :as args} close-modal!]
  [:div
   {:class (uu/cm (if curtain?
                    "flex gap-4"
                    "flex justify-between w-full"))}
   [button/secondary-hollow
    {:on-click (fn [_]
                 (rf/dispatch [m/close-creator args])
                 (when (fn? close-modal!)
                   (close-modal!)))}
    (loc/tr :cancel)]
   [button/primary-solid
    {:on-click (fn [_]
                 (rf/dispatch [m/start-create args]))
     :disabled? true}
    (loc/tr :processing)]])

(defn field-editor
  [{:keys [secondary-args editor-type value error] :as args}]
  ;; secondary-args => currency-field
  [:div
   {:class (uu/cm "flex flex-col gap-1")}
   (if-not secondary-args
     ;; hack: force re-render to trigger default-options loading from opensearch
     ^{:key (when (= editor-type :editor.type/search)
              (str value))}
     [input/view
      args]
     [input/currency-view
      args])
   (when (seq error)
     [:div
      {:class (uu/cm "text-[12px] text-danger-light-text-accent")}
      (some-> error first :error-message)])])
